import { RecipeFields } from 'config/recipes';
import { SignUpFormFields } from 'config/sign_up_form';

export const CreateAccountPageSteps = {
  ...SignUpFormFields,
  request: 'request',
};

export const CreateRecipePageSteps = {
  ...RecipeFields,
  confirmation: 'confirmation',
  request: 'request',
};

export const EditRecipePageSteps = {
  ...RecipeFields,
  menu: 'menu',
};

const Routes = {
  HOME_PAGE: '/',

  CREATE_RECIPE_PAGE: '/recipe/create/:step',
  createRecipe: (step = CreateRecipePageSteps.title) =>
    `/recipe/create/${step}`,

  LOGIN: '/login',

  CREATE_ACCOUNT: '/create_account/:step',
  createAccount: (step = CreateAccountPageSteps.firstName) =>
    `/create_account/${step}`,

  MY_RECIPES: '/my_recipes',

  RECIPE: '/recipe/:id',
  recipe: (id) => `/recipe/${id}`,

  EDIT_RECIPE: '/recipe/edit/:id/:step?',
  editRecipe: (id) => (step = EditRecipePageSteps.menu) =>
    `/recipe/edit/${id}/${step}`,

  BOOKMARKS: '/bookmarks',

  LOGOUT: '/logout',
};

export default Routes;
